import __vue_component__ from './TableRowCell.vue.js';

//
var script = {
  components: {
    TableRowCell: __vue_component__
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    row: {
      type: Object,
      default: () => ({})
    },
    stickyLeft: {
      type: Boolean,
      default: false
    },
    stickyRight: {
      type: Boolean,
      default: false
    },
    isActiveRow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Table/TableRow.vue_rollup-plugin-vue=script.js